import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.app/gatsby-image
 * - `StaticQuery`: https://gatsby.app/staticquery
 */

type Props = {
  className?: string;
  alt: string;
  path: string;
};

type NodeFluid = {
  fluid: {
    originalName: string;
  };
};

function Image({ alt, className, path }: Props) {
  const { allImageSharp } = useStaticQuery(graphql`
    query {
      allImageSharp {
        nodes {
          fluid(maxWidth: 800, quality: 80) {
            aspectRatio
            sizes
            src
            srcSet
            originalName
            originalImg
          }
        }
      }
    }
  `);

  const asset = allImageSharp.nodes.find((node: NodeFluid) => node.fluid.originalName === path);
  if (!asset) {
    return <span>Error image {path}</span>;
  }
  return <Img alt={alt} className={className} fluid={asset.fluid} fadeIn={false} loading="lazy" />;
}

export default Image;
